import { create } from 'zustand';

const useStore = create((set) => ({
  spxData: [],
  vixData: [],
  marketStatus: [],
  topStrikes: [],
  vvixData: [],
  spxGexData: [],
  marketStateSignals: [],
  originalSRData: {},
  marketAINormalizedData: [],
  showSrLines: true,
  currentData: 'spx',

  setSpxData: (data) => set({ spxData: data }),
  setVixData: (data) => set({ vixData: data }),
  setMarketStatus: (data) => set({ marketStatus: data }),
  setTopStrikes: (data) => set({ topStrikes: data }),
  setVvixData: (data) => set({ vvixData: data }),
  setSpxGexData: (data) => set({ spxGexData: data }),
  setMarketStateSignals: (data) => set({ marketStateSignals: data }),
  setMarketAINormalizedData: (data) => set({ marketAINormalizedData: data }),

  setOriginalSRData: (key, data) => set((state) => ({
    originalSRData: {
      ...state.originalSRData,
      [key]: data,
    },
  })),

  toggleData: (data) => set((state) => {
    const showSrLines = data === 'spx';
    return { currentData: data, showSrLines };
  }),
}));

export default useStore;










